'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function LocalExportController(navigatorModel, mapContentExporter, freemindExport, mapMetadataModel) {
	let currentObjectUrl;
	const obj = observable(this),
		complete = function (content, mimeType, title, extension) {
			obj.cleanup();
			currentObjectUrl =
				navigatorModel.toObjectUrl(content, mimeType);
			obj.dispatchEvent('result',
				extension,
				title + '.' + extension,
				currentObjectUrl
			);
			obj.dispatchEvent('stage', 'exported');
		},
		getName = function (content) {
			return mapMetadataModel.getCurrentName() || content.title || 'Exported-Mind-Mup';
		};

	obj.cleanup = function () {
		if (currentObjectUrl) {
			navigatorModel.revokeObjectUrl(currentObjectUrl);
			currentObjectUrl = undefined;
		}
	};
	obj.exportToMM = function () {
		return mapContentExporter.makeExportable().then((content) => {
			complete(freemindExport(content), 'application/x-freemind', getName(content), 'mm');
		}, () => {
			obj.dispatchEvent('stage', 'error');
		});
	};
	obj.exportToMMXml = function () {
		mapContentExporter.makeExportable().then((content) => {
			complete(freemindExport(content), 'text/xml',  getName(content), 'mm');
		}, () => {
			obj.dispatchEvent('stage', 'error');
		});
	};
	obj.exportToMup = async () => {
		obj.dispatchEvent('stage', 'progress');
		try {
			const content = await  mapContentExporter.makeExportable();
			complete(JSON.stringify(content, null, 2), 'application/json', getName(content), 'mup');
		} catch (e) {
			console.error(e);
			obj.dispatchEvent('stage', 'error');
		}
	};
};
